import { useDeviceId } from '@capsicum/common';
import { browserName, browserVersion, isMobile, mobileModel, mobileVendor, osName } from 'react-device-detect';

export const useWebPushDeviceInfo = () => {
	const deviceId = useDeviceId();

	const deviceName = isMobile
		? `${mobileVendor} ${mobileModel} ${browserName} ${browserVersion}`
		: `${osName} ${browserName} ${browserVersion}`;

	return {
		deviceId,
		deviceName
	};
};
